import React from 'react'
import {Cloud, renderSimpleIcon, fetchSimpleIcons} from 'react-icon-cloud'

const useIcons = (slugs: string[]) => {
  const [icons, setIcons] = React.useState<any>()
  React.useEffect(() => {
    fetchSimpleIcons({slugs}).then(setIcons)
  }, [slugs])

  if (icons) {
    return Object.values(icons.simpleIcons).map((icon: any) => renderSimpleIcon({
      icon,
      size: 200,
      aProps: {
        href: '#',
        onClick: (e: any) => e.preventDefault()
      }
    }))
  }
  
  return <span>Loading...</span>
}

const slugs = [
  "cplusplus",
  "c",
  "python",
  "go",
  "rust",
  "ruby",
  "typescript",
  "javascript",
  "gnubash",
  "postgresql",
  "redis",
  "docker",
  "linux",
  "git",
  "graphql",
  "react",
  "nodedotjs",
  "pytorch",
  "tensorflow",
  "jupyter",
  "webrtc",
  "qemu",
  "googlecloud",
  "amazonwebservices",
  "postman",
  "numpy",
  "llvm",
  "tailwindcss"
]

export const SkillCloud = () => {
  const icons = useIcons(slugs)

  return <Cloud>
    {icons}
  </Cloud>
}